<template>
  <div v-if="utilisateur" class=" is-marginless is-paddingless section section-details">
    <div class="entete" :class="{'border-entete': !isCommercialPresse
      && !moduleSecteurActive}">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailUtilisateur.title', { nomPrenom: getUsername })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button">
              <router-link :to="{ name: 'l.parametrage.collaborateurs' }"
                           :class="{'text-access-no-permission':
                                   !checkPermissions(permsCollaborateurs.lecture)}">
              {{ $t('general.button.return') }}
              </router-link>
            </button>
            <dropdownButton
              v-if="utilisateur"
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permsCollaborateurs.maj"
              :actions="actionSecondary"
              @click="$router.push({ name: 'm.parametrage.collaborateurs-edit',
                params: { id: utilisateur.id} })">
                {{ $t('detail.buttons.edit') }}
            </dropdownButton>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'informationCollaborateur'}"
              @click="activeTab = 'informationCollaborateur'">
            {{ $t('detailUtilisateur.tab.information') }}
          </li>
          <li :class="{'is-active': activeTab === 'listeCommissions'}"
              @click="activeTab = 'listeCommissions'" v-if="isCommercialPresse">
            {{ $t('detailUtilisateur.tab.commissions') }}
          </li>
          <li :class="{'is-active': activeTab === 'AppSecteurUtilisateur'}"
              @click="activeTab = 'AppSecteurUtilisateur'" v-if="moduleSecteurActive">
            {{ $t('detailUtilisateur.tab.secteur') }}
          </li>
        </ul>
      </div>
    </div>
    <component :is="activeTab" :utilisateur="utilisateur" :logo="logo"
               :disableActions="true"
               v-if="utilisateur" :commercialId="utilisateur.id"></component>
    <b-modal
      v-model="openPoupArchivageDesarchivage"
      has-modal-card
      class="modal">
      <pop-up-prevention
        @no="openPoupArchivageDesarchivage = false"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="messHeader"
        :mess-description="messDescription"
        @validateQuestions="archiverUtilisateur"
        :questions="questions">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { get, archiver } from '@/api/utilisateur/index';
import dropdownButton from '@/components/general/button/dropdownButton';
import getLogo from '@/services/general/getLogo';
import intToGuid from '@/services/general/transformIntToGuid';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { COLLABORATEURS } from '@/configuration/general/permissionsParametrageConf';
import messageErreur from '@/services/general/messageErreur';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import informationCollaborateur
  from '@/components/parametrage/collaborateur/informationCollaborateur';
import listeCommissions from '@/components/commissions/listeCommissions';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import AppSecteurUtilisateur from '@/components/parametrage/utilisateur/secteurUtilisateur';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const societes = createNamespacedHelpers('societe');

export default {
  name: 'c_utilisateur',
  data() {
    return {
      utilisateur: null,
      activeTab: 'informationCollaborateur',
      permsCollaborateurs: COLLABORATEURS,
      logo: null,
      questions: [],
      openPoupArchivageDesarchivage: false,
      messHeader: '',
      messDescription: '',
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    dropdownButton,
    informationCollaborateur,
    listeCommissions,
    popUpPrevention,
    AppSecteurUtilisateur,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...societes.mapGetters({
      societesInformations: 'societesInformations',
    }),
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.' + (this.utilisateur.actif ? 'archiver' : 'desarchiver')),
          action: () => { this.openPopup(); },
          permissionAction: this.permsCollaborateurs.supprimer,
        },
      ];
      return actions;
    },
    getUsername() {
      return nomPrenomGetter(this.utilisateur);
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    isCommercialPresse() {
      return (this.utilisateur.profil === COMMERCIAL
        || this.utilisateur.profil === DIRECTEUR_COMMERCIAL) && this.modulePresseActive;
    },
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeUtilisateur.title'), route: { name: 'l.parametrage.collaborateurs' }, isActive: false },
        { title: this.$t('detailUtilisateur.title', { nomPrenom: this.getUsername }), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      updateUserToParametre: 'updateUtilisateurToParametre',
    }),
    ...societes.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    loadAgenceOfUser() {
      const agences = [];
      this.utilisateur.agences.forEach((agence) => {
        const societeFind = this.societesInformations.find((societe) => {
          return societe.id === agence.societeId;
        });
        const agenceFind = societeFind.agences.find((agenceFind) => {
          return agenceFind.id === agence.agenceId;
        });
        agenceFind.libelleSociete = societeFind.libelle;
        agenceFind.idSociete = societeFind.id;
        agences.push(agenceFind);
      });
      agences.sort((a, b) => {
        return a.libelle.localeCompare(b.libelle);
      });
      this.utilisateur.agences = agences;
    },
    openPopup() {
      this.messHeader = this.utilisateur.actif ? this.$t('listeUtilisateur.popUpArchivageDesarchivage.titleArchivage')
        : this.$t('listeUtilisateur.popUpArchivageDesarchivage.titleDesarchivage');
      this.messDescription = this.utilisateur.actif
        ? this.$t('listeUtilisateur.popUpArchivageDesarchivage.infoArchivageDesarchivage.archivage') : '';
      this.questions = this.utilisateur.actif ? [] : [{
        key: 0,
        message: 'listeUtilisateur.popUpArchivageDesarchivage.infoArchivageDesarchivage.desarchivage',
        value: false,
      }];
      this.openPoupArchivageDesarchivage = true;
    },
    async archiverUtilisateur(values) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let connexionAutorisee = false;
        if (values?.length > 0) {
          const find = values.find(v => v.key === 0);
          if (find) connexionAutorisee = find.value;
        }
        await archiver({
          id: this.utilisateur.id,
          archiver: this.utilisateur.actif,
          connexionAutorisee: connexionAutorisee,
        });
        messageSucces(this.utilisateur.actif
          ? this.$i18n.t('listeUtilisateur.popUpArchivageDesarchivage.success.archivage')
          : this.$i18n.t('listeUtilisateur.popUpArchivageDesarchivage.success.desarchivage'));
        this.utilisateur.actif = !this.utilisateur.actif;
        this.utilisateur.connexionAutorisee = connexionAutorisee;
        this.updateUserToParametre(this.utilisateur);
        this.openPoupArchivageDesarchivage = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logo = await getLogo(intToGuid(this.$route.params.id));
      await this.loadSocietes({});
      this.utilisateur = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: nomPrenomGetter(this.utilisateur) }));
      await this.loadAgenceOfUser();
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.civilite]);
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
